import { createAction, createActions } from 'redux-actions';

const namespace = 'userInfo';

export const USER_INFO_RESET_ERROR = `${namespace}/USER_INFO_RESET_ERROR`;

export const USER_INFO_LOAD_REQUESTED = `${namespace}/USER_INFO_LOAD_REQUESTED`;
export const USER_INFO_LOAD_SUCCEEDED = `${namespace}/LOAD_USER_INFO_SUCCESS`;
export const USER_INFO_LOAD_FAILED = `${namespace}/LOAD_USER_INFO_FAILURE`;

export const USER_AMEND_LOAD_REQUESTED = `${namespace}/LOAD_USER_AMEND_REQUEST`;
export const USER_AMEND_LOAD_SUCCEEDED = `${namespace}/LOAD_USER_AMEND_SUCCESS`;
export const USER_AMEND_LOAD_FAILED = `${namespace}/LOAD_USER_AMEND_FAILURE`;

export const USER_CREATE_LOAD_REQUESTED = `${namespace}/CREATE_USER_REQUEST`;
export const USER_CREATE_LOAD_SUCCEEDED = `${namespace}/CREATE_USER_SUCCESS`;
export const USER_CREATE_LOAD_FAILED = `${namespace}/CREATE_USER_FAILURE`;

export const USER_AUTHENTICATE_LOAD_REQUESTED = `${namespace}/AUTHENTICATE_USER_REQUEST`;
export const USER_AUTHENTICATE_LOAD_SUCCEEDED = `${namespace}/AUTHENTICATE_USER_SUCCESS`;
export const USER_AUTHENTICATE_LOAD_FAILED = `${namespace}/AUTHENTICATE_USER_FAILURE`;

export const resetUserInfoError = createAction(USER_INFO_RESET_ERROR);
export const loadUserInfoRequest = createAction(USER_INFO_LOAD_REQUESTED);

export const {
  userInfo: {
    loadUserInfoSuccess,
    loadUserInfoFailure,
    loadUserAmendRequest,
    loadUserAmendSuccess,
    loadUserAmendFailure,
    createUserRequest,
    createUserSuccess,
    createUserFailure,
    authenticateUserRequest,
    authenticateUserSuccess,
    authenticateUserFailure,
  },
} = createActions({
  [USER_INFO_LOAD_SUCCEEDED]: payload => payload,
  [USER_INFO_LOAD_FAILED]: payload => payload,
  [USER_AMEND_LOAD_REQUESTED]: payload => payload,
  [USER_AMEND_LOAD_SUCCEEDED]: payload => payload,
  [USER_AMEND_LOAD_FAILED]: payload => payload,
  [USER_CREATE_LOAD_REQUESTED]: payload => payload,
  [USER_CREATE_LOAD_SUCCEEDED]: payload => payload,
  [USER_CREATE_LOAD_FAILED]: payload => payload,
  [USER_AUTHENTICATE_LOAD_REQUESTED]: payload => payload,
  [USER_AUTHENTICATE_LOAD_SUCCEEDED]: payload => payload,
  [USER_AUTHENTICATE_LOAD_FAILED]: payload => payload,
});

